import { render, staticRenderFns } from "./SocialOrganicCampaignDetailsComponent.vue?vue&type=template&id=410aca46&scoped=true"
import script from "./SocialOrganicCampaignDetailsComponent.vue?vue&type=script&lang=js"
export * from "./SocialOrganicCampaignDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./SocialOrganicCampaignDetailsComponent.vue?vue&type=style&index=0&id=410aca46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410aca46",
  null
  
)

export default component.exports